<template>
	<div class="salepoint-info">
		<div class="row">
			<div>
				<h3 class="gray-50">
					ПНФП №{{ salepoint.code }}
					<span class="txp-count" v-if="isChiefCashier">
						<span>{{ txpPosesCount }}</span> TapXphone
					</span>
				</h3>
				<div class="address gray-40">{{ salepoint.name }}, {{ salepoint.branch }}</div>
			</div>
			<div>
				<NP-Button type="button" v-if="showTransferButton" @click.stop="openTransferModal"> Перезакріпитися </NP-Button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ControlCenterInfo',
	props: {
		salepoint: { type: Object, default: null },
		txpPosesCount: { type: Number, default: 0 },
		isChiefCashier: { type: Boolean, default: false },
		showTransferButton: { type: Boolean, default: false },
		openTransferModal: { type: Function, default: null }
	}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/mixins';
@import '@assets/scss/shared';
@import '@assets/scss/variables';

h3 {
	font-family: Proxima Nova Semibold;
}
.salepoint-info {
	margin-top: 20px;
	background-color: $white;
	border-radius: $border-radius;
	box-sizing: border-box;
	min-height: 88px;
	padding: 20px 24px;
	.address {
		font-size: 14px;
		margin-top: 8px;
	}
	.row {
		display: flex;
		justify-content: space-between;
	}
	.txp-count {
		background: $gray-5;
		border-radius: 50px;
		font-weight: bold;
		font-size: 12px;
		color: $gray-40;
		padding: 5px 16px 4px 8px;
		position: relative;
		left: 6px;
		top: -2px;
		span {
			background: $gray-50;
			border-radius: 4px;
			font-weight: bold;
			font-size: 10px;
			line-height: 12px;
			display: inline-block;
			margin-right: 2px;
			padding: 3px 3px 2px;
			color: $white;
		}
	}
	@include mobile() {
		& {
			padding: 16px;
		}
		.row {
			flex-direction: column;
			.address {
				margin-bottom: 10px;
			}
		}
	}
}
</style>
